import {translate} from 'i18n'
import {GiftshopProfileSocialMediaType} from 'types'

export function transformSocialType(item?: GiftshopProfileSocialMediaType) {
  switch (item) {
    case 'twitter':
      return 'X'
    case 'tiktok':
      return 'TikTok'
    case 'linkedin':
      return 'LinkedIn'
    case 'whatsapp':
      return 'WhatsApp'
    case 'other':
      return translate('global:other')
    default:
      return item ? item.charAt(0).toUpperCase() + item.substring(1) : ''
  }
}

export function textSpacer(text: string, spaceEvery?: number) {
  let formatted = ''
  for (let i = 0; i < text.length; i += 1) {
    formatted += text.charAt(i)
    formatted += (i + 1) % (spaceEvery || 4) === 0 ? ' ' : ''
  }
  if (formatted.endsWith(' ')) {
    formatted = formatted.substring(0, formatted.length - 1)
  }
  return formatted
}
